// src/utils/user.js

/**
 * Extracts the first name from a full name string
 * @param {string} fullName - The full name to extract from
 * @returns {string} The extracted first name or empty string if no name provided
 */
export const getFirstName = (fullName) => {
  if (!fullName) return '';
  return fullName.split(' ')[0];
};

/**
 * Gets user's first name from various possible sources
 * @param {Object} options
 * @param {Object} [options.profile] - User profile object
 * @param {Object} [options.user] - Firebase user object
 * @param {Object} [options.cachedProfile] - Cached profile from storage
 * @returns {string} User's first name or empty string
 */
export const getUserFirstName = ({ profile, user, cachedProfile } = {}) => {
  return (
    cachedProfile?.firstName ||
    getFirstName(profile?.name) ||
    getFirstName(user?.displayName) ||
    ''
  );
};
